import CircleIcon from "./CircleIcon.jsx";

export default CircleIcon;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/circleIcon/index.js